var BlimpExt = new Class({
	Extends: Blimp,

	options: {
		show_veil: true,
		veil_opacity: 0.7,
		rpc_url: null,
		allow_others: false,
		cache: true,
		auto_open: false,
		backOnClose: false,
		scrollable: true,
		allowToClose: false,
		put_others_behind: false,
		fullscreen: false,
		withThumbnails: false,
		display: null,
		page: null,
		vscroll: false,
	},

	initialize: function (link, options) {
		this.setOptions(options);
		this._link = link || new Element('a', { 'href': '#', 'data-rpc': this.options.rpc_url, 'style': 'display: none' }).inject(document.body); //works even without any real link (useful for maps)
		this.opts = this.options;
		this.draggable = this.options.draggable;

		this.state = false;
		this.build();

		if (this.options.auto_open) {
			this._link.fireEvent('click');
		}
	},

	build: function () {
		Blimp.instances.include(this);
		this.addEvent('hide', this.destroy_and_rebuild.bind(this));

		this.active = true;
		this.first_load = true;

		this.parent();

		if (this.options.draggable) {
			window.addEvents({
				'resize': function () {
					if (Core.is_visible(this._element)) {
						this.center_popup();
					}
				}.bind(this)
			});
		}

		if (!this.options.scrollable && (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android')) {
			this.options.scrollable = true;
		}
		if (this.options.draggable && !this.options.scrollable) {
			window.addEvents({
				'scroll': function () {
					if (Core.is_visible(this._element)) {
						this.center_popup();
					}
				}.bind(this)
			});
		}
	},

	retrieve_url: function () {
		var url = this._link.getAttribute('data-rpc') || this._link.get('href') || this.options.rpc_url;

		if (!url || url == '' || url == '#') return;

		var first_char = url.substring(0, 1);

		if (first_char == '#') {
			url = url.substring(1, url.length);
			this._link.set('data-rpc', url);
		}

		return url;
	},

	destroy_and_rebuild: function () {
		this._element.dispose();

		if (this._link) {
			this._link.removeEvents('click');

			this._link.addEvent('click:once', function (e) {
				if (e && e.stop) {
					e.stop();
				}

				this.fx = null;
				this.fireEvent('fetch', [this, this._link]);
				this.fetch(this._link.get('data-rpc') || this._link.get('href'));
			}.bind(this));
		}
	},

	get_data: function (data) {
		var cls = this._link.getProperty('class');

		if (this._link.getProperty('data-class')) {
			cls = this._link.getProperty('data-class');
		}

		var _onpage_content = this._link.getNext('.' + cls + '_content') || this._link.getElement('.' + cls + '_content') || this._link.getParent().getElement('.' + cls + '_content');

		if (_onpage_content) {
			this.content = _onpage_content.dispose();
			this.content.removeClass(cls + '_content').addClass(cls + '_box');

			if (data) {
				this.data = data;
			}
		} else if (data) {
			this.data = data;

			if (this.options.get_content) {
				this.content = this.options.get_content(this, data);
			} else if (data.content) {
				this.content = (new Element('.' + cls + '_box', { html: this.data.content })).dispose();
			}
		} else {
			document.body.style.cursor = 'default';
			return;
		}

		this.process();
	},

	post_process: function () {
		var self = this;
		if (!this.content.getParent()) {
			this.inject(this.content);

			if (this.options.show_veil) {
				this.content.addClass('_has_veil');
			}
		}

		if (this.loader) {
			this.loader.minus();
		}

		if (this.options.show_veil) {
			this.build_veil();
		}

		this.post_process_build();

		document.body.style.cursor = 'default';

		this.fireEvent('postRpc', this);

		if (this.data && this.data.status && this.data.status == true) {
			this.fireEvent('success');
		}

		// add sign up links
		this.add_signup_links();
	},

	submit: function (ev) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		var self = this;
		window.crRecaptcha.execute(function () { self.handle_form_submit() });

		// remove click callback
		this.content.getElement('.button').removeEvents('click');
	},

	post_process_build: function () {
		var _email_us = this._element.getElement('.w_blimp_contact_us') || this._element.getElement('.w_blimp_form.button');

		if (_email_us) {
			new Blimp.Form(_email_us, {
				draggable: true,
				show_veil: true,
				allow_others: this.options.fullscreen ? true : false,
				put_others_behind: this.options.fullscreen || this.options.put_others_behind ? true : false
			});
		}
		var _encrypted = this._element.getElements('.encrypted');
		if (_encrypted && _encrypted.length > 0) {
			_encrypted.each(function (el) {
				Core.add_encrypted_link(el);
			});
		}

		Core.add_videos_link(this._element);

		this.fireEvent('beforeShow');
		this.show();
	},

	show: function () {
		if (!this.options.allow_others || this.options.put_others_behind) {
			Blimp.instances.each(function (blp) {
				if (blp && blp != this && blp.state != false) {
					if (this.options.put_others_behind) {
						blp._element.addClass('_behind');
					} else {
						blp.hide();
					}
				}
			}.bind(this));
		}

		document.body.style.cursor = 'default';

		if (this.data) {
			this.implement_tracking(this.data);
		}

		this._element.removeClass(Gv.cloak);
		this._element.removeClass(Gv.hidden);

		if (this.draggable && !this.options.get_content)
			this.center_popup();

		if (this.options.show_veil) {
			this.handle_self_show();
		}

		this.state = true;
		this.fireEvent('show', [this]);
	},

	hide: function () {
		if (this.options.put_others_behind) {
			Blimp.instances.each(function (blp) {
				if (blp && blp != this && blp.state != false) {
					if (this.options.put_others_behind) {
						blp._element.removeClass('_behind');
					}
				}
			}.bind(this));
		} else if (this._element.hasClass('_behind')) {
			this._element.removeClass('_behind');
			Blimp.instances.each(function (blp) {
				if (this != blp && blp.state) {
					blp.hide();
				}
			}.bind(this));
			return;
		}

		// close only the save message popup
		if (this.onSavePopup && this.save_blimp) {
			this.save_blimp.hide();

			return;
		}

		if (this.options.backOnClose) {
			window.history.back();

			return;
		}

		if (this.options.auto_open && !this.options.allowToClose) return;

		this.fireEvent('beforeHide');

		// for Market insight landing page
		document.fireEvent('miPopupClose');

		if (this._element) {
			this._element.addClass(Gv.cloak);
			this._element.addClass(Gv.hidden);

			if (this.options.show_veil) {
				this.handle_self_hide();
			}

			this.state = false;
			this.fireEvent('hide', [this]);
		}
	},

	handle_self_show: function () {
		if (!this._veil) return;

		this._veil.fade(this.options.veil_opacity);
	},

	handle_self_hide: function () {
		if (!this._veil) return;

		this._veil.fade('out');
	},

	build_veil: function () {
		this.parent();

		this._veil.addClass(this.options.cls + '_veil');
		this._veil.inject(document.id(document.body), 'top');

		this._veil.removeEvents().addEvent('click', function () {
			if (!this.options.backOnClose) {
				this.hide();
				angular.element(document.querySelector('html')).removeClass('no-scroll');
			}
		}.bind(this));
	},

	fetch: function (location) {
		if (!this.active) return;

		document.body.style.cursor = 'wait';

		if (this.loader) {
			this.loader.plus();
		}

		if (this.request) {
			this.request.cancel();
		}

		if (!this.options.cache) {
			this.content = null;
			if (this._sv) this._sv = null;
			if (this._pg) this._pg = null;
			if (this._fp) this._fp = null;
			if (this._mp) this._mp = null;
			if (this._vd) this._vd = null;
		}

		if (!this.content || !this.options.cache) {
			if (location && location != '' && location != '#') {
				this.request = new Request.JSON({
					url: location,
					noCache: true,
					onSuccess: function (data) {
						this.get_data(data);
						if (!this.options.cache) {
							this.request = null;
						}

						this.add_contact_button(this._element);

					}.bind(this)
				}).get();
			} else {
				this.get_data();
			}
		} else {
			this.process();
		}
	},

	add_contact_button: (element) => {
		let contactButton = element.getElement('.button-contact');
		if (contactButton) {
			contactButton.addEvent('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				var event;
				event = document.createEvent("HTMLEvents");
				event.initEvent("crPopupOpen-" + contactButton.getAttribute('data-popup-name'), true, true);
				document.dispatchEvent(event);
			});
		}
	},

	center_popup: function () {
		this._element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
			win_size = window.getSize(),
			el_size = this._element.getSize();

		var pos_y = this.positionY = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y) / 2));

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = this.positionX = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x) / 2));

		// for popup v3 december 2023
		if (this._element && this._element.getElement('#email_form')) {
			this._element.setStyles({
				position: 'fixed'
			});
			pos_y = Math.floor(Math.max(0, (win_size.y - el_size.y) / 2));
			pos_x = Math.floor(Math.max(0, (win_size.x - el_size.x) / 2));
			console.log(pos_x, pos_y);
		}

		if (this.options.fullscreen) {
			this._element.setStyles({
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0
			});
		} else if (this.options.animation) {
			if (!this.fx) {
				this.fx = new Fx.Morph(this._element, { link: 'cancel', transition: 'back:out', duration: 0 });
				this.fx.set({
					'top': pos_y,
					'left': pos_x
				});
			} else {
				this.fx.start({
					'top': pos_y,
					'left': pos_x
				});
			}
		} else {
			this._element.setStyles({
				top: pos_y,
				left: pos_x
			});
		}
	},

	add_extra: function (noCompile) { //used in SearchResultsMap
		if (this.options.cache && !this.first_load) return;

		var self = this;

		this.first_load = false;
		this.links_work = false;

		this._popup = this._element.getElement('.w_popup');
		this._monitor = this._element.getElement('.photogallery_container');

		if (!noCompile) {
			Core.compile_html(self._element.getElement('.cr-save-to-profile'));
		}

		this.add_links_functionality();

		// display the current widget
		this.show_widget(this.options.display);

		new Blimp.Form(this._element.getElement('.w_blimp_form.link-icon'), {
			draggable: true,
			show_veil: false,
			allow_others: true,
			put_others_behind: true
		});

		var _signin_links = this._element.getElements('.w_blimp_signin');
		if (_signin_links) {
			_signin_links.each(function (_link) {
				_link.addEvent('click', function () {
					self.hide();
				});
			})
		}

		// To compile
		let compile = true;
		// check if the contact popup already exists or not
		let contactButton = this._element.getElement('.button-contact');
		if (contactButton) {
			let popupName = contactButton.getAttribute('data-popup-name');
			// check if there is already existing popup outisde of the current element
			let popups = document.getElements(`cr-popup[data-popup-name="${popupName}"].ng-isolate-scope`);
			if (popups && popups.length > 0) {
				compile = false;
			}
		}
		var toCompile = this._element.getElement('.to-compile');
		if (!noCompile && compile && toCompile) {
			Core.compile_html(toCompile);
		}

		// For Listing Contact button
		var _contact_btn = this._element.getElement('.contact_btn');
		if (_contact_btn) {
			_contact_btn.addEvent('click', function (e) {
				self._popup.addClass('_on_contact_form');

				if (self.has_the_form) {
					var _close_btn = self._element.getElement('.form_wrapper .close_btn');
					_close_btn && _close_btn.focus();
					return;
				}

				self.has_the_form = true;
				Core.compile_html(self._element.getElement('.form_wrapper'));

				var _close_btn = self._element.getElement('.form_wrapper .close_btn');
				if (_close_btn) {
					_close_btn.addEvent('click', function () {
						self._popup.removeClass('_on_contact_form');
						_contact_btn.focus();
					});

					// focus on _close
					_close_btn.focus();
				}
			})
		}
	},

	build_close: function () {
		this.parent();

		if (this.options.backOnClose) {
			if (window.history.length == 1) {
				this.close.hide();
			}
		} else if (this.options.auto_open && !this.options.allowToClose) {
			this.close.hide();
		}
	},

	add_links_functionality: function () {
		var self = this;
		if (!this._monitor) {
			return;
		}

		if (!this._monitor.getParent()) {
			this._monitor = this._element.getElement('.frame');
		}

		var _video_link = this._video_link = this._element.getElement('a.videos');
		var _pg_link = this._pg_link = this._element.getElement('a.photogallery');
		var _fp_link = this._fp_link = this._element.getElement('a.floorplan');
		var _sv_link = this._sv_link = this._element.getElement('a.street_view');
		var _mp_link = this._mp_link = this._element.getElement('a.view_on_map');
		var _vd_link = this._vd_link = this._element.getElement('a.video');

		if (_video_link) {
			_video_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_videos();

				if (_sv_link) _sv_link.removeClass('_active');
				if (_fp_link) _fp_link.removeClass('_active');
				if (_mp_link) _mp_link.removeClass('_active');
				if (_vd_link) { _vd_link.removeClass('_active') };
				if (_pg_link) _pg_link.removeClass('_active');

				_video_link.addClass('_active');
			});
		}


		if (_fp_link) {
			_fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_floorplan();

				if (_video_link) _video_link.removeClass('_active');
				if (_sv_link) _sv_link.removeClass('_active');
				if (_pg_link) _pg_link.removeClass('_active');
				if (_mp_link) _mp_link.removeClass('_active');
				if (_vd_link) { _vd_link.removeClass('_active') };

				_fp_link.addClass('_active');
			});
		}

		if (_pg_link) {
			_pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_gallery();

				if (_video_link) _video_link.removeClass('_active');
				if (_sv_link) _sv_link.removeClass('_active');
				if (_fp_link) _fp_link.removeClass('_active');
				if (_mp_link) _mp_link.removeClass('_active');
				if (_vd_link) { _vd_link.removeClass('_active') };

				_pg_link.addClass('_active');
			});
		}

		if (_sv_link) {
			_sv_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_streetview();

				if (_video_link) _video_link.removeClass('_active');
				if (_pg_link) { _pg_link.removeClass('_active') };
				if (_fp_link) { _fp_link.removeClass('_active') };
				if (_mp_link) { _mp_link.removeClass('_active') };
				if (_vd_link) { _vd_link.removeClass('_active') };

				_sv_link.addClass('_active');
			});
		}

		if (_mp_link) {
			_mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_map();

				if (_video_link) _video_link.removeClass('_active');
				if (_pg_link) { _pg_link.removeClass('_active') };
				if (_fp_link) { _fp_link.removeClass('_active') };
				if (_sv_link) { _sv_link.removeClass('_active') };
				if (_vd_link) { _vd_link.removeClass('_active') };

				_mp_link.addClass('_active');
			});
		}

		if (_vd_link) {
			_vd_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_video();

				if (_video_link) _video_link.removeClass('_active');
				if (_pg_link) { _pg_link.removeClass('_active') };
				if (_fp_link) { _fp_link.removeClass('_active') };
				if (_mp_link) { _mp_link.removeClass('_active') };
				if (_sv_link) { _sv_link.removeClass('_active') };

				_vd_link.addClass('_active');
			});
		}

		setTimeout(function () {
			var tmpLinks = [_video_link, _pg_link, _fp_link, _mp_link, _sv_link, _vd_link];
			var anyActiveLink = false;
			for (var i = 0; i < tmpLinks.length; i++) {
				if (tmpLinks[i] && tmpLinks[i].hasClass("_active")) {
					anyActiveLink = true;
					break;
				}
			}
			if (!anyActiveLink) {
				for (var i = 0; i < tmpLinks.length; i++) {
					if (tmpLinks[i]) {
						tmpLinks[i].fireEvent("click");
						break;
					}
				}
			}
		}, 0);
	},

	set_videos: function () {
		var self = this;
		if (this._pg) this._pg.dispose();
		if (this._fp) this._fp.dispose();
		if (this._sv) this._sv.dispose();
		if (this._mp) this._mp.dispose();
		if (this._vd) this._vd.dispose();

		if (!this._video) {
			this.videogallery = new PagePhotogallery(this._monitor, {
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				in_popup: true,
				fullscreen_mode: this.options.fullscreen,
				missing_img: Res_i + '/l/video-default.svg',
				videosOnly: true,
				no_fullscreen_opt: true,
				onCallback: function () {
					self._video = self._monitor.getElement('.w_photogallery') || self._monitor.getElement('img');
				}
			});
		} else {
			this._video.inject(this._monitor);
		}
	},

	set_gallery: function () {
		var self = this;
		if (this._video) this._video.dispose();
		if (this._fp) this._fp.dispose();
		if (this._sv) this._sv.dispose();
		if (this._mp) this._mp.dispose();
		if (this._vd) this._vd.dispose();

		if (!this._pg) {
			this.photogallery = new PagePhotogallery(this._monitor, {
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				in_popup: true,
				fullscreen_mode: this.options.fullscreen,
				missing_img: Res_i + '/l/missing_grey_new_gallery_big_v2.png',
				onCallback: function () {
					self._pg = self._monitor.getElement('.w_photogallery') || self._monitor.getElement('img');
				}
			});
		} else {
			this._pg.inject(this._monitor);
		}
	},

	set_floorplan: function () {
		var self = this;
		if (!this._fp) {

			if (this._video) this._video.dispose();
			if (this._pg) this._pg.dispose();
			if (this._sv) this._sv.dispose();
			if (this._mp) this._mp.dispose();
			if (this._vd) this._vd.dispose();

			new PagePhotogallery(this._monitor, {
				data: this._fp_link.data,
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				missing_img: Res_i + '/l/missing_grey_new_gallery_big_v2.png',
				show_floorplan: true,
				fullscreen_mode: this.options.fullscreen,
				onCallback: function () {
					self._fp = self._monitor.getElement('.w_photogallery');
				}
			});
		} else {
			this._monitor.adopt(this._fp);
			if (this._video) this._video.dispose();
			if (this._pg) this._pg.dispose();
			if (this._sv) this._sv.dispose();
			if (this._mp) this._mp.dispose();
			if (this._vd) this._vd.dispose();
		}
	},

	set_streetview: function () {
		var self = this;

		if (!this._sv) {
			self._monitor.addClass('_loading');

			new Remote({
				rpc: self._sv_link.get('data-rpc-map'),
				onSuccess: function () {
					var sv_data = this.get_data();

					if (sv_data) {
						var html = '<div class="w_streetview_map"></div>' +
							'<div class="w_streetview_pano"></div>' +
							'<div class="none w_streetview_config">' +
							'{' +
							'"lat": ' + (sv_data.ini.lat || 40.7611181) + ',' +
							'"lng": ' + (sv_data.ini.lng || -73.9774162) +
							'}' +
							'</div>';

						self._sv = new Element('div', {
							'class': 'street_view_map',
							'html': html
						}).inject(self._monitor);
						if (self._video) self._video.dispose();
						if (self._pg) self._pg.dispose();
						if (self._fp) self._fp.dispose();
						if (self._mp) self._mp.dispose();
						if (self._vd) self._vd.dispose();

						new Streetview(self._sv);

						self._monitor.removeClass('_loading');
					}
				}
			});
		} else {
			if (this._video) this._video.dispose();
			if (this._pg) this._pg.dispose();
			if (this._fp) this._fp.dispose();
			if (this._mp) this._mp.dispose();
			if (this._vd) this._vd.dispose();

			this._sv.inject(self._monitor);
		}
	},

	set_map: function () {
		var self = this;
		if (!this._mp) {
			self._monitor.addClass('_loading');

			new Remote({
				rpc: self._mp_link.get('data-rpc-map'),
				method: 'get',
				onSuccess: function () {
					var mp_data = this.get_data();

					if (mp_data) {
						self._mp = new Element('div', {
							'class': 'map'
						}).inject(self._monitor);

						self.map = new SimpleMap(self._mp, {
							zoom: mp_data.ini.zoom,
							max_zoom: 17,
							min_zoom: 10,
							lat: mp_data.ini.lat,
							lng: mp_data.ini.lng,
							transit_layer: true,
							street_view_control: true,
							onMapReady: function () {
								this.add_marker({
									lat: mp_data.ini.lat,
									lng: mp_data.ini.lng,
									icon: mp_data.ini.markers_path + 'base.png',
									bubble_content: mp_data.base_location.name
								});
							}
						});
						if (self._video) self._video.dispose();
						if (self._pg) self._pg.dispose();
						if (self._fp) self._fp.dispose();
						if (self._sv) self._sv.dispose();
						if (self._vd) self._vd.dispose();

						self._monitor.removeClass('_loading');
					}
				}
			});
		} else {
			if (this._video) this._video.dispose();
			if (this._pg) this._pg.dispose();
			if (this._fp) this._fp.dispose();
			if (this._sv) this._sv.dispose();
			if (this._vd) this._vd.dispose();

			this._mp.inject(self._monitor);
		}
	},

	set_video: function () {
		var self = this;
		if (!this._vd) {
			var id = 'vimeo_' + Math.floor((Math.random() * 1000) + 1);

			this._vd = new Element('div.video_container', {
				'html': '<iframe id="' + id + '" src="' + ('https:' == document.location.protocol ? 'https://' : 'http://') + 'player.vimeo.com/video/' + this._vd_link.getAttribute('data-vimeo-id') + '?api=1&player_id=' + id + '" width="100%" height="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
			}).inject(self._monitor);
			if (this._video) this._video.dispose();
			if (self._pg) self._pg.dispose();
			if (self._fp) self._fp.dispose();
			if (this._mp) this._mp.dispose();
			if (self._sv) self._sv.dispose();

			self._monitor.removeClass('_loading');

		} else {
			if (this._video) this._video.dispose();
			if (this._pg) this._pg.dispose();
			if (this._fp) this._fp.dispose();
			if (this._mp) this._mp.dispose();
			if (this._sv) this._sv.dispose();

			this._vd.inject(self._monitor)
		}
	},

	show_widget: function (widget) {
		var _el;

		widget = widget || this.options.display;
		// display the current widget
		switch (widget) {
			case 'video':
				_el = this._video_link;
				break;
			case 'floorplan':
				_el = this._fp_link;
				break;
			case 'map':
				_el = this._mp_link;
				break;
			case 'streetview':
				_el = this._st_link;
				break;
			case 'video-bld':
				_el = this._vd_link;
				break;
			default:
				_el = this._pg_link;
		}

		if (_el && !_el.hasClass('_active')) {
			_el.fireEvent('click');
		}
	}
});

//static
Blimp.instances = [];
